import styled from '@emotion/styled/macro';
import { keyframes } from '@emotion/react';
import { colors, shadows, views } from '../../../../common/styles/theme.styles';
import { flexCenter } from '../../../../common/styles/combos.styles';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const VaultBulkEditHeaderWrapper = styled.div`
    background-color: ${colors.darkGray1};
    border-radius: 31px;
    height: 58px;
    padding: 11px 13px 11px 24px;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: ${fadeIn} 0.3s ease-out forwards;
    width: auto;
    max-width: none;
    backdrop-filter: blur(8px);
    container-type: inline-size;
    
    position: sticky;
    bottom: 32px;
    left: calc(260px + 45px); /* Sidebar + page padding */
    right: calc(45px + 15px); /* Page padding */
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.24), 0px 4px 12px rgba(0, 0, 0, 0.16);
    width: 100%;

    ${views.tablet} {
        bottom: 24px;
        padding: 11px 13px 11px 20px;
    }
`;

export const VaultBulkEditHeaderText = styled.div`
    color: #fff;
    font-size: 16px;
    font-weight: 450;
    line-height: 1.265em;
    white-space: nowrap;
    flex: 1;
`;

export const VaultBulkEditHeaderCancelEditButton = styled.div`
    cursor: pointer;
    border-radius: 20px;
    padding: 0px 16px 0px 12px;
    ${flexCenter};
    background-color: #fff;
    gap: 2px;
    height: 36px;
    font-size: 14px;
    color: ${colors.darkGray1};
    font-weight: 500;
    line-height: 1.265em;
    text-align: right;
    border: none;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
    transition: background-color 0.2s ease;
    white-space: nowrap;
    
    &:hover {
        background-color: #fff;
    }
    
    @container (max-width: 500px) {
        padding: 0px 8px;
        gap: 0;
    }
    
    ${props => props.disabled ? `opacity: 0.6; cursor: default;` : ``}
`;

export const VaultBulkEditHeaderCancelEditButtonText = styled.span`
    @container (max-width: 500px) {
        display: none;
    }
`;

export const VaultCancelButtonIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    ${flexCenter}
`;

export const VaultItemSelectedCheckboxWrapper = styled.div`
    opacity: 1;
    cursor: pointer;
    margin-right: 12px;
    ${props => props.disabled ? `visibility: hidden` : ``}
`;

export const VaultItemSelectedCheckbox = styled.div`
    border-radius: 3px;
    width: 12px;
    height: 12px;
    ${flexCenter};
    ${props => props.isSelected ? `
        background-color: #fff;
    ` : props.isPartialSelected ? `
        border: 1px solid #fff;
    ` : `
        border: 1px solid rgba(255, 255, 255, 0.5);
        box-shadow: ${shadows.toggleShadow};
    `}
`;

export const VaultBulkEditActionButton = styled.div`
    cursor: pointer;
    border-radius: 20px;
    padding: 0px 16px 0px 12px;
    ${flexCenter};
    gap: 2px;
    height: 36px;
    font-size: 16px;
    font-weight: 450;
    line-height: 1.265em;
    transition: all 0.2s ease;
    white-space: nowrap;
    background-color: #2F3236;
    color: #FFFFFF;
    border: none;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
    
    &:hover {
        background-color: #3A3E42;
    }
    
    &.active {
        background-color: #3A3E42;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.24), 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
    }
    
    @container (max-width: 660px) {
        padding: 0px 8px;
        gap: 0;
        
        & > span {
            display: none;
        }
    }
    
    ${props => props.disabled ? `
        opacity: 0.6; 
        cursor: default;
        &:hover {
            background-color: #2F3236;
        }
        &.active {
            background-color: #2F3236;
        }
    ` : ``}
`;

export const VaultBulkEditActionButtonText = styled.span`
    display: flex;
    align-items: center;
    gap: 4px;
    @container (max-width: 660px) {
        display: none;
    }
`;

export const VaultTagsDropdownMenu = styled.div`
    width: 200px;
    background: ${colors.darkGray1};
    border-radius: 8px;
    padding: 4px 0;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.24), 0px 4px 12px rgba(0, 0, 0, 0.16);
    border: 1px solid #3A3E42;
`;

export const VaultTagsDropdownMenuItem = styled.div`
    padding: 12px 16px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 450;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background-color 0.15s ease;
    
    &:hover {
        background-color: #3A3E42;
    }
    
    &:first-of-type {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    
    &:last-of-type {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
    
    svg {
        width: 12px;
        height: 12px;
        color: rgba(255, 255, 255, 0.6);
    }
`; 